/**
 * 救援服务单定位页面
 * 创建时间：2017-07-24
 * 创建人：zhan
 * 修改人：sun shujuan
 */
<template>
	<div v-bind:style="mapStyle">
	<!--	<div style="width:100%;height:70px;border:1px dotted #ddd;">-->
			<div class="row">
				<label class="col-sm-1" style="line-height:30px;">救援地址：</label>
				<div class="col-sm-11">
					<input type="text" id="suggestIdL" size="20" placeholder="请输入地址" class="form-control" @focus.once="searchAdds" v-model="resAds" @blur = "resetAdds($event)"/>
					<div id="searchResultPanelL" style="border:1px solid #C0C0C0;width:150px;height:auto; display:none;"></div>
				</div> 
			</div>
			<div class="row">
				<label class="col-sm-1" style="line-height:30px;">当前地址：</label>
				<div class="col-sm-11">
					<input type="text" class="form-control" v-model="curAds" readonly/>
				</div> 
			</div>
	<!--	</div>-->
			<br />
		<baidu-map style="height: 300px;box-shadow: 3px 3px 2px #888888" 
			:center="mapCenter"
			:zoom="mapZoom" 
			:scroll-wheel-zoom="enableScroll" 
			@ready="ready">
		</baidu-map>
		<div class="form-horizontal">
			<br />
			<div class="form-group">
				<div class="col-sm-12 text-center">
					<a class="btn btn-primary white" @click="saveAddress" v-if="levv!=3">保存</a>
				</div>
			</div>
		</div>
		<!--提示弹框开始-->
		<tab-modal ref="modalTip" size="small" title="提示" :scroll="scrollTop" @cancel="closetip">
			{{tipContent}}
			<div slot="footer"> 
				<button class="btn btn-primary" @click="closetip">确定</button>
			</div>
		</tab-modal>
	</div>	
</template>

<script> 
	import TabModal from 'components/common/TabModal'
	export default{
		name: "PageRescueServiceOrderLocate",
		components:{
			TabModal
		},
		data() {
			return {
				//地图类
				mapStyle: {
					position:'relative',
					width: '100%',
					height: '450px',
					padding:'0 15px'
				},
				mapCenter:{lng: 120.39, lat: 36.073},
				mapZoom:15,
				enableScroll:true,
				curAds:'',
				resAds:'',
				resPts:{},
				scrollTop:'',
				tipContent:''
			};
		},
		computed:{
			levv(){
	    		return this.$store.state.user.levv
	    	}
		},
		props:['points','address','type'],
		mounted(){
			this.initAds()//初始化地址 
		}, 
		methods: {
			initAds(){
				if(this.address != ''){
					this.resAds = this.address
					this.resPts = JSON.parse(this.points) 
					this.curAds = this.address
				}else{
					this.resAds = ''
					this.curAds = ''
				}
			},
			ready(obj){
				const { BMap, map } = obj;
				this.map = map;
				this.BMap = BMap;
				//1,比例尺
				map.addControl(new BMap.ScaleControl());  
				//2，定位 
				if(this.points!='' && this.address != ''){ 
					let pts = JSON.parse(this.points) 
					this.addRescueMarker(pts) 
				}  
			},
			addRescueMarker(pts){
				const {BMap,map} = this; 
				let points = new BMap.Point(pts.lng,pts.lat)
				let marker = new BMap.Marker(points,{enableDragging:true})
				map.addOverlay(marker)
				map.setCenter(points)
				const that = this; 
				marker.addEventListener('dragging',function(e){
					var timer;
					console.log('dragging')
					return function(e){
						if(timer){
							clearTimeout(timer)
						}
						timer = setTimeout((e)=>{
							that.switchPtsToAds(e.point)
						},500)
					}  
				})
				marker.addEventListener('dragend',function(e){ 
					that.switchPtsToAds(e.point)
					that.resPts = e.point
				})
			},
			switchPtsToAds(pt){ 
				const {BMap,map} = this;
				const that = this;
				var geoc = new BMap.Geocoder(); 
				let res = ''
				geoc.getLocation(pt, function(rs){
					var addComp = rs.addressComponents;
					res = addComp.province + ", " + addComp.city + ", " + addComp.district + ", " + addComp.street + ", " + addComp.streetNumber
					that.curAds = res 
					console.log(res)
				}); 
			},
			resetAdds(e){//当清空输入框时（在编辑模式下）赋值为原地址
				if(e.target.value==''){
					e.target.value = this.address
					this.curAds = this.address
				} 
			},
			//输入地址
			searchAdds(){
				var ac = this.searchCommon('suggestIdL','searchResultPanelL')
				var myValue;
				let self = this;
				ac.addEventListener("onconfirm", function(e) {    //鼠标点击下拉列表后的事件
				var _value = e.item.value;
					myValue = _value.province +  _value.city +  _value.district +  _value.street +  _value.business;
					G("searchResultPanelL").innerHTML ="onconfirm<br />index = " + e.item.index + "<br />myValue = " + myValue;
					self.setPlace(myValue);
				}); 
			},
			searchCommon(id,resId){
				const {map,BMap} = this;
				var ac = new BMap.Autocomplete(    //建立一个自动完成的对象
					{"input" : id
					,"location" : map
				});
				ac.addEventListener("onhighlight", function(e) {  //鼠标放在下拉列表上的事件
					var str = "";
					var _value = e.fromitem.value;
					var value = "";
					if (e.fromitem.index > -1) {
						value = _value.province +  _value.city +  _value.district +  _value.street +  _value.business;
					}    
					str = "FromItem<br />index = " + e.fromitem.index + "<br />value = " + value;
					
					value = "";
					if (e.toitem.index > -1) {
						_value = e.toitem.value;
						value = _value.province +  _value.city +  _value.district +  _value.street +  _value.business;
					}    
					str += "<br />ToItem<br />index = " + e.toitem.index + "<br />value = " + value;
					G(resId).innerHTML = str;
				});
				return ac
			},
			setPlace(myValue){//地址检索时调用的方法
				const {map} = this;
				map.clearOverlays();    //清除地图上所有覆盖物
				const that = this;
				var myFun = function(){
					let resObj = local.getResults().getPoi(0)
					if(!resObj){
						that.$refs.modalTip.open()
						that.tipContent = '地图定位失败，请重新输入或换个相邻地址' 
						return
					}
					var pp = local.getResults().getPoi(0).point;    //获取第一个智能搜索的结果
					map.centerAndZoom(pp, 18); 
					let marker = new BMap.Marker(pp,{enableDragging:true});
					map.addOverlay(marker); 
					const self = that;
					that.resPts = {lng:pp.lng,lat:pp.lat}
					marker.addEventListener('dragging',function(e){
						self.switchPtsToAds(e.point)
					})
					marker.addEventListener('dragend',function(e){
						self.switchPtsToAds(e.point)
						self.resPts = e.point
					})
				}
				var local = new BMap.LocalSearch(map, { //智能搜索
					onSearchComplete: myFun
				});
				local.search(myValue);
				this.resAds = myValue;
				this.curAds = myValue;
			},	 
			saveAddress(){ 
				const obj = {
					address:this.curAds,
					points:this.resPts,
					type:this.type
				} 
				this.$emit('saveNewPos',obj)
			},
			closetip(){
				this.$refs.modalTip.close()
			}
		}
	}
	function G(id) {
		return document.getElementById(id);
	}
</script>


// WEBPACK FOOTER //
// PageRescueServiceOrderLocate.vue?4edda060